// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiError,
  CreatePartition,
  PartitionEntity,
  PartitionList,
  PartitionStatusPatch,
  UpdatePartitionSpec,
} from '../models/index';
import {
  ApiErrorFromJSON,
  ApiErrorToJSON,
  CreatePartitionFromJSON,
  CreatePartitionToJSON,
  PartitionEntityFromJSON,
  PartitionEntityToJSON,
  PartitionListFromJSON,
  PartitionListToJSON,
  PartitionStatusPatchFromJSON,
  PartitionStatusPatchToJSON,
  UpdatePartitionSpecFromJSON,
  UpdatePartitionSpecToJSON,
} from '../models/index';

export interface V1EnvironmentsEnvironmentPartitionsByNameNameGetRequest {
  environment: string;
  name: string;
}

export interface V1EnvironmentsEnvironmentPartitionsGetRequest {
  environment: string;
  cloudProvider?: V1EnvironmentsEnvironmentPartitionsGetCloudProviderEnum;
}

export interface V1EnvironmentsEnvironmentPartitionsPostRequest {
  environment: string;
  createPartition: CreatePartition;
}

export interface V1PartitionsIdDeleteRequest {
  id: string;
}

export interface V1PartitionsIdGetRequest {
  id: string;
}

export interface V1PartitionsIdPutRequest {
  id: string;
  updatePartitionSpec: UpdatePartitionSpec;
}

export interface V1PartitionsIdStatusPatchRequest {
  id: string;
  partitionStatusPatch: PartitionStatusPatch;
}

/**
 *
 */
export class PartitionsApi extends runtime.BaseAPI {
  /**
   * Get a partition by operational name
   */
  async v1EnvironmentsEnvironmentPartitionsByNameNameGetRaw(
    requestParameters: V1EnvironmentsEnvironmentPartitionsByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentPartitionsByNameNameGet().',
      );
    }

    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling v1EnvironmentsEnvironmentPartitionsByNameNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/partitions/by-name/{name}`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );
    urlPath = urlPath.replace(
      `{${'name'}}`,
      encodeURIComponent(String(requestParameters['name'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get a partition by operational name
   */
  async v1EnvironmentsEnvironmentPartitionsByNameNameGet(
    requestParameters: V1EnvironmentsEnvironmentPartitionsByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionEntity> {
    const response =
      await this.v1EnvironmentsEnvironmentPartitionsByNameNameGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * List partitions
   */
  async v1EnvironmentsEnvironmentPartitionsGetRaw(
    requestParameters: V1EnvironmentsEnvironmentPartitionsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionList>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentPartitionsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['cloudProvider'] != null) {
      queryParameters['cloud_provider'] = requestParameters['cloudProvider'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/partitions`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionListFromJSON(jsonValue),
    );
  }

  /**
   * List partitions
   */
  async v1EnvironmentsEnvironmentPartitionsGet(
    requestParameters: V1EnvironmentsEnvironmentPartitionsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionList> {
    const response = await this.v1EnvironmentsEnvironmentPartitionsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * IMS assigns the id and operational name (ADR-0005).
   * Create a partition
   */
  async v1EnvironmentsEnvironmentPartitionsPostRaw(
    requestParameters: V1EnvironmentsEnvironmentPartitionsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentPartitionsPost().',
      );
    }

    if (requestParameters['createPartition'] == null) {
      throw new runtime.RequiredError(
        'createPartition',
        'Required parameter "createPartition" was null or undefined when calling v1EnvironmentsEnvironmentPartitionsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/partitions`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreatePartitionToJSON(requestParameters['createPartition']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionEntityFromJSON(jsonValue),
    );
  }

  /**
   * IMS assigns the id and operational name (ADR-0005).
   * Create a partition
   */
  async v1EnvironmentsEnvironmentPartitionsPost(
    requestParameters: V1EnvironmentsEnvironmentPartitionsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionEntity> {
    const response = await this.v1EnvironmentsEnvironmentPartitionsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * References from clusters are cleared, not deleted.
   * Delete a partition
   */
  async v1PartitionsIdDeleteRaw(
    requestParameters: V1PartitionsIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/partitions/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * References from clusters are cleared, not deleted.
   * Delete a partition
   */
  async v1PartitionsIdDelete(
    requestParameters: V1PartitionsIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1PartitionsIdDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Get a partition
   */
  async v1PartitionsIdGetRaw(
    requestParameters: V1PartitionsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/partitions/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get a partition
   */
  async v1PartitionsIdGet(
    requestParameters: V1PartitionsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionEntity> {
    const response = await this.v1PartitionsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * PUT replaces the full spec.
   * Update a partition\'s spec
   */
  async v1PartitionsIdPutRaw(
    requestParameters: V1PartitionsIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdPut().',
      );
    }

    if (requestParameters['updatePartitionSpec'] == null) {
      throw new runtime.RequiredError(
        'updatePartitionSpec',
        'Required parameter "updatePartitionSpec" was null or undefined when calling v1PartitionsIdPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/partitions/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdatePartitionSpecToJSON(
          requestParameters['updatePartitionSpec'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionEntityFromJSON(jsonValue),
    );
  }

  /**
   * PUT replaces the full spec.
   * Update a partition\'s spec
   */
  async v1PartitionsIdPut(
    requestParameters: V1PartitionsIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionEntity> {
    const response = await this.v1PartitionsIdPutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes.
   * Patch a partition\'s status
   */
  async v1PartitionsIdStatusPatchRaw(
    requestParameters: V1PartitionsIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PartitionEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdStatusPatch().',
      );
    }

    if (requestParameters['partitionStatusPatch'] == null) {
      throw new runtime.RequiredError(
        'partitionStatusPatch',
        'Required parameter "partitionStatusPatch" was null or undefined when calling v1PartitionsIdStatusPatch().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/partitions/{id}/status`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PartitionStatusPatchToJSON(
          requestParameters['partitionStatusPatch'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PartitionEntityFromJSON(jsonValue),
    );
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes.
   * Patch a partition\'s status
   */
  async v1PartitionsIdStatusPatch(
    requestParameters: V1PartitionsIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PartitionEntity> {
    const response = await this.v1PartitionsIdStatusPatchRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const V1EnvironmentsEnvironmentPartitionsGetCloudProviderEnum = {
  Gcp: 'gcp',
  Aws: 'aws',
  Azure: 'azure',
} as const;
export type V1EnvironmentsEnvironmentPartitionsGetCloudProviderEnum =
  (typeof V1EnvironmentsEnvironmentPartitionsGetCloudProviderEnum)[keyof typeof V1EnvironmentsEnvironmentPartitionsGetCloudProviderEnum];
